/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Caption_Published_SuccessInputs */

const en_ateliere_connect_caption_published_success = /** @type {(inputs: Ateliere_Connect_Caption_Published_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption file published successfully!`)
};

const fr_ateliere_connect_caption_published_success = /** @type {(inputs: Ateliere_Connect_Caption_Published_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier de sous-titres publié avec succès !`)
};

const de_ateliere_connect_caption_published_success = /** @type {(inputs: Ateliere_Connect_Caption_Published_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertiteldatei erfolgreich veröffentlicht!`)
};

const it_ateliere_connect_caption_published_success = /** @type {(inputs: Ateliere_Connect_Caption_Published_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File didascalia pubblicato con successo!`)
};

const ru_ateliere_connect_caption_published_success = /** @type {(inputs: Ateliere_Connect_Caption_Published_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файл с подписью успешно опубликован!`)
};

const es_ateliere_connect_caption_published_success = /** @type {(inputs: Ateliere_Connect_Caption_Published_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡El archivo de subtítulos se publicó correctamente!`)
};

const zh_cn2_ateliere_connect_caption_published_success = /** @type {(inputs: Ateliere_Connect_Caption_Published_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕文件发布成功！`)
};

const ja_ateliere_connect_caption_published_success = /** @type {(inputs: Ateliere_Connect_Caption_Published_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションファイルが正常に公開されました。`)
};

const hi_ateliere_connect_caption_published_success = /** @type {(inputs: Ateliere_Connect_Caption_Published_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन फाइल सफलतापूर्वक प्रकाशित हो गई!`)
};

const pt_pt2_ateliere_connect_caption_published_success = /** @type {(inputs: Ateliere_Connect_Caption_Published_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de legenda publicado com sucesso!`)
};

/**
* | output |
* | --- |
* | "Caption file published successfully!" |
*
* @param {Ateliere_Connect_Caption_Published_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_caption_published_success = /** @type {((inputs?: Ateliere_Connect_Caption_Published_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Caption_Published_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_caption_published_success(inputs)
	if (locale === "de") return de_ateliere_connect_caption_published_success(inputs)
	if (locale === "it") return it_ateliere_connect_caption_published_success(inputs)
	if (locale === "ru") return ru_ateliere_connect_caption_published_success(inputs)
	if (locale === "es") return es_ateliere_connect_caption_published_success(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_caption_published_success(inputs)
	if (locale === "ja") return ja_ateliere_connect_caption_published_success(inputs)
	if (locale === "hi") return hi_ateliere_connect_caption_published_success(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_caption_published_success(inputs)
	return en_ateliere_connect_caption_published_success(inputs)
});